import { DialogComponent } from '@theme/dialog';
import { loadSearchDrawerPopular } from './search-drawer-popular.js';

/**
 * Search drawer — same top-to-bottom drop animation as the cart drawer.
 *
 * @extends {DialogComponent}
 */
class SearchDrawerComponent extends DialogComponent {
  #focusTimeout;

  showDialog() {
    super.showDialog();

    const predictiveSearch = this.querySelector('predictive-search-component');
    if (predictiveSearch && typeof predictiveSearch.resetSearch === 'function') {
      predictiveSearch.resetSearch(true);
    }

    loadSearchDrawerPopular();

    clearTimeout(this.#focusTimeout);
    this.#focusTimeout = setTimeout(() => {
      const input = this.querySelector('.search-input');
      if (input instanceof HTMLInputElement) {
        input.focus();
      }
    }, 120);
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('search-drawer-component')) {
  customElements.define('search-drawer-component', SearchDrawerComponent);
}
